<template>
	<div class="content">
		<div class="container-fluid">
			<card>
				<div class="row">
					<div class="col-12 col-md-7">
						<div class="card">
							<div class="card-body">
								<h5>İzinler</h5>
								<card v-for="permission in permissions" :key="permission.id">
									<div class="row mb-0">
										<div class="col-4 font-weight-bold">Erişilecek Kaynak</div>
										<div class="col-3 font-weight-bold">İzinler</div>
										<div class="col-2 font-weight-bold">Kısıtlama</div>
										<div class="col-2 font-weight-bold">Eylemler</div>
									</div>
									<div class="row mb-0" >
										<div class="col-4">{{permission.name_tr}}</div>
										<div class="col-3">
											<Checkbox v-model="permission.r" >
												<template slot="label">
													Okuma
												</template>
											</Checkbox>
											<Checkbox :readonly="permission.resource === 'Logs'" v-model="permission.w">
												<template slot="label">
													Yazma
												</template>
											</Checkbox>
											<Checkbox :readonly="permission.resource === 'Logs'" v-model="permission.d">
												<template slot="label">
													Silme
												</template>
											</Checkbox>
										</div>
										<div class="col-2">
											<Checkbox :readonly="permission.resource === 'Logs'" v-model="permission.ristricted">
												<template slot="label">
													Kısıtlı İzin
												</template>
											</Checkbox>
										</div>
										<div class="col-3">
											<button class="btn btn-primary btn-fill btn-sm" v-on:click="updatePermission(permission)">Kaydet</button>
											<button class="btn btn-danger btn-fill btn-sm" v-on:click="deletePermission(permission.id)">Sil</button>
										</div>
									</div>
									<label v-if="permission.resource === 'Logs'" class="text-warning"><i class="fas fa-exclamation"></i> Sistem hareketlerine yazma ve silme izni verilemez. Kısıtlama yapılamaz</label>
								</card>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-5">
						<div class="card">
							<div class="card-body">
								<h5>İzin Ekle</h5>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<label class="input-group-text border-0 bg-white" for="inputGroupSelect01">Kaynak</label>
									</div>
									<select class="form-control" v-model="resourceWithType">
										<option v-for="item in resources" :key="item.value" :value="item">{{item.value}}</option>
									</select>
								</div>
								<div class="input-group mb-3">
									<Checkbox v-model="newPermission.r">
										<template slot="label">
											Okuma
										</template>
									</Checkbox>
									<Checkbox :readonly="newPermission.resource === 'Logs'" v-model="newPermission.w">
										<template slot="label">
											Yazma
										</template>
									</Checkbox>
									<Checkbox :readonly="newPermission.resource === 'Logs'" v-model="newPermission.d">
										<template slot="label">
											Silme
										</template>
									</Checkbox>
									<Checkbox :readonly="newPermission.resource === 'Logs'" v-model="newPermission.ristricted">
										<template slot="label">
											Kısıtlı izin
										</template>
									</Checkbox>
									<label v-if="newPermission.resource === 'Logs'" class="text-warning"><i class="fas fa-exclamation"></i> Sistem hareketlerine yazma ve silme izni verilemez. Kısıtlama yapılamaz</label>
								</div>


								<button class="btn btn-success btn-fill" @click="savePermission()">Ekle</button>

							</div>
							<div class="card-footer">
								<label v-if="newPermission.resource" class="text-info"><i class="fas fa-exclamation"></i> Kullanıcının bir kaynağa erişimini açtığınız zaman. O kaynağa bağlı bazı diğer kaynaklara da erişim izni kazanabilir.</label>

							</div>
						</div>
					</div>
				</div>



			</card>
		</div>
	</div>
</template>

<script>
	import Card from 'src/components/UIComponents/Cards/Card.vue'
	import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'

	export default {
		data: function () {
			return {
				permissions:null,
				resourceWithType:{},
				newPermission:{
					user_id: this.$route.params.id,
					resource: null,
					ristricted:false,
					type:null,
					nameTr:null,
					r:false,
					w:false,
					d:false
				},
				resources:[
				{id:'Images',type:'homeslide', value:'Anasayfa Slider'},
				{id:'Settings',type:'introvideo', value:'İntro Videosu'},
				{id:'Posts',type:'Homeboxes', value:'Anasayfa Kutular'},
				{id:'Posts',type:'Homeinfos', value:'Anasayfa Bilgiler'},
				{id:'Posts',type:'Announcements', value:'Anasayfa Duyurular'},
				{id:'Images',type:'directors', value:'Yönetim Kurulu'},
				{id:'Images',type:'staffs', value:'Federasyon Personeli'},
				{id:'Images',type:'allleaders', value:'Başkanlarımız'},
				{id:'Settings',type:'history', value:'Tarihçe'},
				{id:'Categories',type:'subboards', value:'Alt Kurullar'},
				{id:'Images',type:'subboards', value:'Alt Kurullar(Kişiler)'},
				{id:'Images',type:'provincialoffices', value:'İl Temsilcilikleri'},
				{id:'Posts',type:'BankInformations', value:'Hesap Numaraları'},
				{id:'Images',type:'mainstatusinstructions', value:'Ana Statü Talimatlar'},
				{id:'Settings',type:'leadername', value:'Başkanın Bölümü-İçerik'},
				{id:'Images',type:'leadergallery', value:'Başkanın Bölümü-Fotogaleri'},
				{id:'Images',type:'pressgallery', value:'Başkanın Bölümü-Yazılı Basın'},
				{id:'Posts',type:'LeaderArticles', value:'Başkanın Bölümü-Başkanın Yazıları'},
				{id:'Slider',type:'LeaderArticles', value:'Başkanın Bölümü-Yazı Sıralama'},
				{id:'Posts',type:'DigitalPress', value:'Başkanın Bölümü-Dijital Basın'},
				{id:'Slider',type:'DigitalPress', value:'Başkanın Bölümü-Dijital Basın Sıralama'},
				{id:'Images',type:'sitegallery', value:'Galeri'},
				{id:'Images',type:'videogallery', value:'Video Galeri'},
				{id:'Categories',type:'reports', value:'Bildiri Kategorileri'},
				{id:'Categories',type:'news', value:'Haber Kategorileri'},
				{id:'Posts',type:'Races', value:'Yarışlar'},
				{id:'Race',type:null, value:'Yarış Başvuruları'},
				{id:'Categories',type:'seasons', value:'Yarış Sezonları'},
				{id:'Users',type:3, value:'Üyeler'},
				{id:'Posts',type:'News', value:'Bildiriler'},
				{id:'Slider',type:'News', value:'Bildiri Sıralama'},
				{id:'Posts',type:'Allnews', value:'Haberler'},
				{id:'Slider',type:'Allnews', value:'Haber Sıralaması'},
				{id:'Posts',type:'ComingFromYou', value:'Sizden Gelenler'},
				{id:'Settings',type:'comingfromyou', value:'Gönderi Oluştur İçerik'},
				{id:'Slider',type:'Featured', value:'Vitrin'},
				{id:'Posts',type:'Activityprogrampage', value:'Faaliyet Programı'},
				{id:'Posts',type:'Cuppointpage', value:'Kupa Puanları'},
				{id:'Settings',type:'activityprogram', value:'Faaliyet Programı İçerik'},
				{id:'Posts',type:'Informationbankspage', value:'Bilgi Bankası'},
				{id:'Settings',type:'informationbank', value:'Bilgi Bankası İçerik'},
				{id:'Posts',type:'Facilities', value:'Tesisler'},
				{id:'Posts',type:'ActivityProgram', value:'Excel Yüklemeleri'},
				{id:'Users',type:2, value:'Kullanıcılar'},
				{id:'Settings',type:'GeneralSettings', value:'Genel Site Ayarları'},
				]
			}
		},
		components: {
			Card,
			Checkbox
		},
		methods: {
			getPermissions: function(){
				this.toggleLoader()
				this.$http.get('/api/user-permissions/get/'+this.newPermission.user_id).then(
					response => {
						this.permissions = response.body
						this.toggleLoader()
					},
					er => {
						this.notifier(
							'top',
							'right',
							'danger',
							'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
							)
						this.toggleLoader()
					})
			},
			nothing: function(){
				return false
			},
			savePermission: function(){
				this.newPermission.resource = this.resourceWithType.id;
				this.newPermission.nameTr = this.resourceWithType.value;
				if(this.resourceWithType.type){
					this.newPermission.type = this.resourceWithType.type;
				}else{
					this.newPermission.type = null;
				}
 				this.toggleLoader()
				this.$http.post('/api/user-permissions/add/', this.newPermission).then(
					response => {
						this.toggleLoader()
						this.notifier('top', 'right', 'success', 'İzinler Başarıyla Kaydedildi')
						this.getPermissions()
						this.newPermission = {
							user_id: this.$route.params.id,
							resource: null,
							ristricted:false,
							type:null,
							nameTr:null,
							r:false,
							w:false,
							d:false
						}
					},
					e => {
						this.toggleLoader()
						this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
					})
			},
			updatePermission: function(prm){
				this.toggleLoader()
				delete prm.user
				delete prm.created
				delete prm.modified
				var id = prm.id
				delete prm.id
				this.$http.post('/api/user-permissions/edit/'+id, prm).then(
					response => {
						this.toggleLoader()
						this.notifier('top', 'right', 'success', 'İzinler Başarıyla Güncellendi')
						this.getPermissions()
					},
					e => {
						this.toggleLoader()
						this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
					})
			},
			deletePermission: function(id){
				this.toggleLoader()
				this.$http.delete('/api/user-permissions/delete/'+id).then(
					response => {
						this.toggleLoader()
						this.notifier('top', 'right', 'danger', 'Kullanıcı İzni Silindi')
						this.getPermissions()
					},
					e => {
						this.toggleLoader()
						this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
					})
			}
		},
		mounted: function () {
			this.$nextTick(function () {
				this.getPermissions()
			})
		}
	}
</script>
<style type="text/css">
.form-check .form-check-label{
	line-height: 13px;
	font-size: 15px;
}
label{
	text-transform: capitalize !important;
	font-size:15px !important;
}
.form-check{
	padding-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/UserModules/Permissions.vue